module.exports = __webpack_public_path__ + "img/avatar0.a5392617.png";